<template>
  <div class="order-totals">
    <component :is="component" v-if="isQuote && showItemTotal">
      <span>Item(s)</span>
      <tml-currency :value="parseFloat(itemTotal)" no-rounding />
    </component>
    <component :is="component" v-if="isQuote && showSetupTotal">
      <span>Setup</span>
      <tml-currency :value="parseFloat(setupTotal)" no-rounding />
    </component>
    <component :is="component" v-if="isQuote && showExtrasTotal">
      <span>Extras</span>
      <tml-currency :value="parseFloat(extrasTotal)" no-rounding />
    </component>
    <component :is="component">
      <span>Subtotal</span>
      <tml-currency :value="parseFloat(subtotal)" no-rounding />
    </component>
    <component :is="component" v-if="showShipping">
      <span>Shipping</span>
      <tml-currency
        v-if="shipping > 0"
        :value="parseFloat(shipping)"
        no-rounding
      />
      <span v-else>Free</span>
    </component>
    <component :is="component" v-if="showTax">
      <span>VAT</span>
      <tml-currency :value="parseFloat(tax)" no-rounding />
    </component>
    <component :is="component" v-if="showDiscount">
      <span>Discount</span>
      <tml-currency :value="parseFloat(discount)" no-rounding />
    </component>
    <component :is="component">
      <span>Total</span>
      <tml-currency :value="parseFloat(total)" no-rounding />
    </component>
  </div>
</template>

<script>
import {splitTests} from '@teemill/common/classes';

export default {
  name: 'CartTotals',

  props: {
    summary: {
      type: Object,
      default: () => {},
    },
    size: {
      type: String, // 'big', 'medium', 'small'
      default: 'big',
    },
    showTax: {
      type: Boolean,
      default: false,
    },
    showShipping: {
      type: Boolean,
      default: true,
    },
    isQuote: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    itemTotal() {
      return this.showTax
        ? this.summary.itemTotalExTax ?? 0
        : this.summary.itemTotal ?? 0;
    },
    extrasTotal() {
      return this.summary.extrasTotal ?? 0;
    },
    setupTotal() {
      return this.summary.setupTotal ?? 0;
    },
    subtotal() {
      return this.showTax
        ? this.summary.subtotalExTax ?? 0
        : this.summary.subtotal ?? 0;
    },
    shipping() {
      return this.summary.shipping ?? 0;
    },
    tax() {
      return this.summary.tax ?? 0;
    },
    discount() {
      return this.summary.discount ?? 0;
    },
    total() {
      return this.summary.total ?? 0;
    },

    isRapanui: () => $store.state.subdomain?.division === 14,

    component() {
      switch (this.size) {
        default:
        case 'big':
          return 'h4';
        case 'medium':
          return 'h5';
        case 'small':
          return 'p';
      }
    },

    showItemTotal() {
      return this.itemTotal > 0;
    },

    showSetupTotal() {
      return this.setupTotal > 0;
    },

    showExtrasTotal() {
      return this.extrasTotal > 0;
    },

    showDiscount() {
      return this.discount > 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.order-totals {
  h4,
  h5,
  p {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>
